import useUsersAccessRightStore from '@/stores/users/accessRight';
import useUiDashboardsStore from '@/stores/ui/dashboards';
import i18n from '@/js/plugins/i18n';
import availableRules from './rules';

let currentPlanning = null;
let isEnabled = false;

export default {
  enable(planning) {
    if (currentPlanning === planning) return;
    currentPlanning = planning;
    isEnabled = true;
  },
  disable() {
    currentPlanning = null;
    isEnabled = false;
  },
  onElementDataChanged({ element, oldData, newData }) {
    if (! isEnabled || ! element || ! oldData || ! newData) return;
    if (element.isDragPlaceholder || element.isResizePlaceholder) return;
    const elPlanning = element.getPlanning?.(); // elements loaded with planning query don't have getPlanning ???
    if (! elPlanning) return;
    if (currentPlanning && currentPlanning.id !== elPlanning.id) return;

    const config = useUsersAccessRightStore().config || {};
    if (config.automations?.length) {
      config.automations.forEach((automation) => {
        if (! automation?.on) return;
        const rule = availableRules[automation.id];
        if (! rule) return; // unknown automation rule

        if (! rule.canRun({ planning: elPlanning, element, oldData, newData, automation })) return;
        rule.run({ planning: elPlanning, element, oldData, newData, automation }, () => {
          // show toast juste before modification to ensure toast order with successive rules
          const uiDashboardsStore = useUiDashboardsStore();
          const elTitle = element.getTitle() || i18n.global.t('helpers.elDefaultTitle', { type: element.getType() });
          uiDashboardsStore.toasts.push({
            color: 'primary',
            text: `${elTitle}\n${i18n.global.t(`AUTOMATIONS.RULES.${rule.id.toUpperCase()}.NAME`)}`,
            icon: 'far fa-bolt',
          });
        });
      });
    }
  },
};
